import store from 'store/storeApp';

export const getDispatch = () => {
  const dispatch = store?.dispatch;

  return dispatch;
};

export const getStateStore = () => {
  const getState = store?.getState;
  return getState;
};

export const getParamsFromStoreRedux = () => {
  return {
    dispatch: getDispatch(),
    getState: getStateStore(),
  };
};
